/** Brief 12, Kapitan - Platforma, in Russian. */
export const ruB12Platform = {
  "plat.shell.title": "Kapitan admin",
  "plat.shell.who": "{name} · Администратор платформы",
  "plat.shell.exit": "Выйти",
  "plat.shell.sections": "Разделы платформы",
  "plat.nav.tenants": "Тенанты",
  "plat.nav.create": "Создать тенанта",
  "plat.nav.support": "Режим поддержки",
  "plat.nav.providers": "Состояние провайдеров",
  "plat.nav.channels": "Состояние каналов",
  "plat.nav.ai": "Расход AI",
  "plat.nav.billing": "Биллинг и тарифы",
  "plat.nav.catalogues": "Каталоги",
  "plat.nav.hotels": "Нормализация отелей",
  "plat.nav.leads": "Заявки с лендинга",
  "plat.nav.credits": "Заявки на кредиты",
  "plat.nav.audit": "Журнал аудита",
  "plat.nav.airports": "Аэропорты",
  "plat.nav.destinations": "Направления",
  "plat.nav.settings": "Системные настройки",
  "plat.nav.system": "Состояние системы",
  "plat.retry": "Повторить",
  "plat.denied": "У вас нет доступа к этому разделу.",
  "plat.loadError": "Не удалось загрузить данные.",
  "plat.prev": "Назад",
  "plat.next": "Вперёд",
  "plat.tenants.title": "Тенанты",
  "plat.tenants.all": "Все тенанты",
  "plat.tenants.sub": "Агентств: {count} · нажмите на строку",
  "plat.tenants.empty": "Агентств нет.",
  "plat.status.active": "Активен",
  "plat.status.suspended_billing": "Остановлен биллингом",
  "plat.status.suspended_admin": "Остановлен админом",
  "plat.status.closed": "Закрыт",
  "plat.col.tenant": "Тенант",
  "plat.col.slug": "Slug",
  "plat.col.status": "Статус",
  "plat.col.tariff": "Тариф",
  "plat.col.credit": "Кредиты",
  "plat.col.activity": "Активность",
  "plat.col.channels": "Каналы",
  "plat.tenant.members": "{tariff} · сотрудников: {count}",
  "plat.tenant.channels": "TG {telegram} · IG {instagram}",
  "plat.tenant.channelsWarn": "{channels} · предупр.: {count}",
  "plat.tenant.back": "← К списку",
  "plat.tenant.cardSub": "Карточка тенанта",
  "plat.tenant.moveStatus": "Изменить статус",
  "plat.tenant.assignTariff": "Назначить тариф",
  "plat.tenant.journal": "Журнал агентства",
  "plat.tenant.balance": "Баланс",
  "plat.tenant.aiMonth": "Расход AI · месяц",
  "plat.tenant.aiMonthValue": "{count} кр",
  "plat.tenant.membersKpi": "Участники",
  "plat.tenant.noTariff": "Нет",
  "plat.card.members": "Участники",
  "plat.card.name": "Имя",
  "plat.card.role": "Роль",
  "plat.card.lastLogin": "Последний вход",
  "plat.card.channels": "Каналы и провайдеры",
  "plat.card.title": "Название",
  "plat.card.kind": "Тип",
  "plat.card.provider": "Провайдер",
  "plat.card.history": "История биллинга и аудит",
  "plat.card.date": "Дата",
  "plat.card.event": "Событие",
  "plat.card.amount": "Сумма",
  "plat.card.empty": "Записей пока нет.",
  "plat.card.profile": "Профиль",
  "plat.card.created": "Создано",
  "plat.card.email": "Email",
  "plat.card.branch": "Филиал",
  "plat.card.active": "Активен",
  "plat.card.inactive": "Неактивен",
  "plat.card.channelsOnly": "Каналы",
  "plat.card.sync": "Последняя синхронизация",
  "plat.card.attention": "Нужно внимание",
  "plat.card.paused": "Остановлен",
  "plat.card.running": "Работает",
  "plat.card.providers": "Провайдеры",
  "plat.card.checked": "Последняя проверка",
  "plat.card.errorRate": "Ошибки, % (24 часа)",
  "plat.card.aiSpend": "Расход AI",
  "plat.card.aiSpendSub": "{from} — {to}. Токены и запуски, без цены.",
  "plat.card.aiEmpty": "За этот период AI не работал.",
  "plat.card.model": "Модель",
  "plat.card.runs": "Запуски",
  "plat.card.playground": "Тест",
  "plat.card.promptTokens": "Входящие токены",
  "plat.card.completionTokens": "Исходящие токены",
  "plat.role.owner": "Владелец",
  "plat.role.branch_manager": "Менеджер",
  "plat.role.moliyachi": "Финансист",
  "plat.role.operator": "Оператор",
  "plat.create.title": "Создать тенанта",
  "plat.create.name": "Название",
  "plat.create.slug": "Slug (если пусто, из названия)",
  "plat.create.timezone": "Часовой пояс",
  "plat.create.currency": "Валюта",
  "plat.create.language": "Язык",
  "plat.create.languageUz": "Узбекский",
  "plat.create.tariff": "Тариф",
  "plat.create.tariffLater": "Позже",
  "plat.create.email": "Email владельца",
  "plat.create.ownerName": "Имя владельца",
  "plat.create.branches": "Филиалы (каждый с новой строки)",
  "plat.create.submit": "Создать тенанта и пригласить владельца",
  "plat.create.done": "Тенант создан",
  "plat.create.error": "Не удалось создать тенанта.",
  "plat.create.emailed": "Приглашение отправлено на {email}.",
  "plat.create.another": "Создать ещё",
  "plat.create.open": "Открыть карточку",
  "plat.support.title": "Режим поддержки",
  "plat.support.new": "Новая сессия поддержки",
  "plat.support.tenant": "Тенант",
  "plat.support.choose": "Выберите",
  "plat.support.duration": "Срок",
  "plat.support.reason": "Причина",
  "plat.support.reasonHint": "Например: тикет 482 · не подключается Telegram",
  "plat.support.write": "Разрешить изменения",
  "plat.support.start": "Начать",
  "plat.support.started": "Режим поддержки начат · {name}",
  "plat.support.startError": "Не удалось начать режим поддержки.",
  "plat.support.active": "Активные сессии",
  "plat.support.activeEmpty": "Активных сессий нет.",
  "plat.support.register": "Журнал сессий",
  "plat.support.registerEmpty": "Сессий нет.",
  "plat.support.staff": "Сотрудник",
  "plat.support.left": "Осталось",
  "plat.support.leftMinutes": "{count} мин",
  "plat.support.ended": "Закрыта",
  "plat.support.expired": "Срок истёк",
  "plat.support.enter": "Войти в агентство",
  "plat.support.close": "Закрыть",
  "plat.support.closed": "Сессия поддержки закрыта.",
  "plat.support.closeError": "Не удалось закрыть сессию.",
  "plat.providers.title": "Состояние провайдеров",
  "plat.providers.block": "Адаптеры провайдеров",
  "plat.providers.sub": "Канарейка · тестовый поиск каждые 5 минут",
  "plat.providers.empty": "Учётных записей провайдеров нет.",
  "plat.providers.adapter": "Адаптер",
  "plat.providers.version": "Версия",
  "plat.providers.canary": "Канарейка",
  "plat.providers.errors": "Ошибки %",
  "plat.providers.breaker": "Circuit breaker",
  "plat.providers.closed": "Закрыт",
  "plat.providers.halfOpen": "Проверка",
  "plat.providers.open": "Открыт",
  "plat.providers.owner": "Ответственный",
  "plat.channels.title": "Состояние каналов",
  "plat.channels.block": "Сессии Telegram и токены Instagram",
  "plat.channels.tg": "Сессии TG",
  "plat.channels.paused": "Приостановлены",
  "plat.channels.ig": "Токены IG",
  "plat.channels.errors": "Ошибки",
  "plat.channels.empty": "Подключённых каналов нет.",
  "plat.channels.channel": "Канал",
  "plat.channels.kind": "Тип",
  "plat.channels.state": "Статус",
  "plat.channels.sync": "Последняя синхронизация",
  "plat.channels.flood": "Ждёт flood-лимит",
  "plat.channels.ok": "Подключён",
  "plat.channels.bad": "Нужно переподключить",
  "plat.channels.pausedRow": "Приостановлен",
  "plat.ai.title": "Расход AI",
  "plat.ai.block": "Расход AI · {month}",
  "plat.ai.credits": "Всего кредитов",
  "plat.ai.tokens": "Токены",
  "plat.ai.avg": "Среднее / тенант",
  "plat.ai.today": "Сегодня",
  "plat.ai.month": "Месяц",
  "plat.ai.model": "Модель",
  "plat.ai.empty": "В этом месяце AI не работал.",
  "plat.ai.noRatio": "Цена кредита не задана: колонки показаны в токенах.",
  "plat.billing.title": "Биллинг и тарифы",
  "plat.billing.tariffs": "Тарифы",
  "plat.billing.addTariff": "+ Добавить тариф",
  "plat.billing.creditPrice": "Изменить цену кредита",
  "plat.billing.topUp": "Пополнить баланс",
  "plat.billing.adjust": "Корректировка",
  "plat.billing.tariff": "Тариф",
  "plat.billing.price": "Цена / мес.",
  "plat.billing.staff": "Сотрудники",
  "plat.billing.staffAny": "без лимита",
  "plat.billing.aiCredits": "AI-кредиты / мес.",
  "plat.billing.state": "Статус",
  "plat.billing.inactive": "Неактивен",
  "plat.billing.note": "1 кредит = {tokens} токенов. Пакетные кредиты сгорают в конце месяца, купленные действуют 12 месяцев.",
  "plat.billing.noteUnset": "Цена кредита пока не задана. Пакетные кредиты сгорают в конце месяца, купленные действуют 12 месяцев.",
  "plat.billing.empty": "Тарифов нет.",
  "plat.billing.adjustments": "Корректировки",
  "plat.billing.adjEmpty": "Корректировок нет.",
  "plat.billing.date": "Дата",
  "plat.billing.amount": "Сумма",
  "plat.billing.reason": "Причина",
  "plat.credit.title": "Цена кредита",
  "plat.credit.tokens": "1 кредит = N токенов",
  "plat.credit.saved": "1 кредит = {tokens} токенов",
  "plat.credit.error": "Не удалось сохранить цену кредита.",
  "plat.grant.title": "Добавить кредиты",
  "plat.grant.credits": "Кредиты",
  "plat.grant.note": "Комментарий",
  "plat.grant.noteHint": "Например: банковский перевод №1182",
  "plat.grant.saved": "{name}: +{count} кредитов",
  "plat.grant.error": "Не удалось добавить кредиты.",
  "plat.adjust.title": "Корректировка баланса",
  "plat.adjust.amount": "Сумма, UZS (минус для уменьшения)",
  "plat.adjust.saved": "Корректировка записана",
  "plat.adjust.error": "Не удалось записать корректировку.",
  "plat.dialog.cancel": "Отмена",
  "plat.dialog.save": "Сохранить",
  "plat.catalogues.title": "Каталоги",
  "plat.catalogues.block": "Глобальные каталоги",
  "plat.catalogues.name": "Каталог",
  "plat.catalogues.count": "Записи",
  "plat.catalogues.updated": "Последнее обновление",
  "plat.catalogues.destinations": "Направления и алиасы",
  "plat.catalogues.airports": "Аэропорты",
  "plat.catalogues.hotels": "Отели (нормализованные)",
  "plat.catalogues.templates": "Шаблоны AI",
  "plat.catalogues.providers": "Список провайдеров",
  "plat.catalogues.inCode": "в коде",
  "plat.hotels.title": "Нормализация отелей",
  "plat.hotels.question": "Это один отель?",
  "plat.hotels.why": "Сходство названий {score}%",
  "plat.hotels.noSuggestion": "Подходящего варианта нет: сохраните как отдельный отель.",
  "plat.hotels.yes": "Да, один отель",
  "plat.hotels.no": "Нет, разные",
  "plat.hotels.merged": "Объединено",
  "plat.hotels.split": "Отмечено как разные",
  "plat.hotels.error": "Не удалось сохранить решение.",
  "plat.hotels.empty": "Очередь пуста",
  "plat.hotels.catalogue": "Отель из каталога",
  "plat.leads.title": "Заявки с лендинга",
  "plat.leads.block": "Заявки с лендинга · форма kapitan-crm.uz",
  "plat.leads.date": "Дата",
  "plat.leads.name": "Имя",
  "plat.leads.agency": "Агентство",
  "plat.leads.phone": "Телефон",
  "plat.leads.city": "Город",
  "plat.leads.state": "Статус",
  "plat.leads.filter": "По статусу",
  "plat.leads.all": "Все",
  "plat.leads.empty": "Заявок с лендинга нет.",
  "plat.leads.move": "Статус",
  "plat.leads.convert": "Сделать агентством",
} as const;
